import { useAtom } from 'jotai';
import { atom } from 'jotai';
import { PackageExpirationDialogType } from '@/interfaces/paid-management';

interface PackageExpirationDialogState {
  open: boolean;
  type: PackageExpirationDialogType | null;
}

const packageExpirationDialogAtom = atom<PackageExpirationDialogState>({
  open: false,
  type: null,
});

export const usePackageExpirationDialog = () => {
  const [state, setState] = useAtom(packageExpirationDialogAtom);

  const openDialog = (type: PackageExpirationDialogType) => {
    setState({
      open: true,
      type,
    });
  };

  const closeDialog = () => {
    setState({
      open: false,
      type: null,
    });
  };

  return {
    ...state,
    openDialog,
    closeDialog,
  };
};
